<template>
    <div style="height: 100%">
        <div id="frame" class="container billing-newtheme">
            <div id="sidepanel">
                <div id="profile">
                    <div class="wrap">
                        <img
                            height="40px"
                            id="profile-img"
                            :src="'/storage' + this.user.profile_image"
                            class="online"
                            alt=""
                        />
                        <p>{{ this.user.name }}</p>
                        <div id="status-options">
                            <ul>
                                <li id="status-online" class="active">
                                    <span class="status-circle"></span>
                                    <p>Online</p>
                                </li>
                                <li id="status-away">
                                    <span class="status-circle"></span>
                                    <p>Away</p>
                                </li>
                                <li id="status-busy">
                                    <span class="status-circle"></span>
                                    <p>Busy</p>
                                </li>
                                <li id="status-offline">
                                    <span class="status-circle"></span>
                                    <p>Offline</p>
                                </li>
                            </ul>
                        </div>
                        <div id="expanded">
                            <label for="twitter-1"
                                ><i
                                    class="fa fa-facebook fa-fw"
                                    aria-hidden="true"
                                ></i
                            ></label>
                            <input
                                id="twitter-1"
                                name="twitter"
                                type="text"
                                value="mikeross"
                            />
                            <label for="twitter-2"
                                ><i
                                    class="fa fa-twitter fa-fw"
                                    aria-hidden="true"
                                ></i
                            ></label>
                            <input
                                id="twitter-2"
                                name="twitter"
                                type="text"
                                value="ross81"
                            />
                            <label for="twitter-3"
                                ><i
                                    class="fa fa-instagram fa-fw"
                                    aria-hidden="true"
                                ></i
                            ></label>
                            <input
                                id="twitter-3"
                                name="twitter"
                                type="text"
                                value="mike.ross"
                            />
                        </div>
                    </div>
                </div>
                <div id="search">
                    <label for="search-input"
                        ><i class="fa fa-search" aria-hidden="true"></i
                    ></label>
                    <input
                        v-model="keyword"
                        id="search-input"
                        type="text"
                        placeholder="Search contacts..."
                    />
                </div>
                <div id="contacts">
                    <ul class="pl-0">
                        <li
                            v-for="u in filteredList" :key="u"
                            class="contact"
                            :class="{ active: selected_user.id === u.id }"
                            v-on:click="getMessages(u)"
                        >
                            <div class="wrap">
                                <span
                                    :title="u.activity_status"
                                    class="contact-status"
                                    :class="{
                                        online: u.activity_status === 'online',
                                        away: u.activity_status === 'offline',
                                    }"
                                ></span>
                                <img
                                    height="40px"
                                    width="40px"
                                    :src="'/storage' + u.image"
                                    alt=""
                                />
                                <div class="meta row">
                                    <p class="name">{{ u.name }}</p>
                                    <div
                                        class="col text-right d-flex justify-content-end p-0"
                                    >
                                        <div
                                            class="dropdown box-drop row"
                                            style="height: 10px"
                                        >
                                            <i
                                                class="fas fa-ellipsis-h ellipsis_icon"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            ></i>
                                            <div
                                                class="dropdown-menu border-0 shadow"
                                                style="left: -150px"
                                            >
                                                <a
                                                    href="javascript:void (0)"
                                                    v-if="
                                                        chat.find(
                                                            (c) =>
                                                                c.sender_id ===
                                                                    u.id ||
                                                                c.receiver_id ===
                                                                    u.id
                                                        ).status === 'open'
                                                    "
                                                    v-on:click="
                                                        blockUser(u.id, 'block')
                                                    "
                                                    class="dropdown-item border-bottom"
                                                    >Block</a
                                                >
                                                <a
                                                    href="javascript:void (0)"
                                                    v-if="
                                                        chat.find(
                                                            (c) =>
                                                                c.sender_id ===
                                                                    u.id ||
                                                                c.receiver_id ===
                                                                    u.id
                                                        ).status === 'block'
                                                    "
                                                    v-on:click="
                                                        blockUser(u.id, 'open')
                                                    "
                                                    class="dropdown-item border-bottom"
                                                    >Unblock</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="content">
                <div class="contact-profile">
<!--                    <img-->
<!--                        height="40px"-->
<!--                        v-if="Object.keys(user).length > 0"-->
<!--                        :src="'/storage' + user.image"-->
<!--                        :alt="user.name"-->
<!--                    />-->
<!--                    <p v-if="Object.keys(user).length > 0">{{ user.name }}</p>-->
                    <div class="social-media">
                        <i class="fa fa-facebook" aria-hidden="true"></i>
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                        <i class="fa fa-instagram" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="messages" id="messages">
                    <ul>
                        <li
                            v-for="message in messages" :key="message.id"
                            :class="{
                                replies: message.receiver.id === user.id,
                                sent: message.sender.id === user.id,
                            }"
                        >
                            <img
                                height="40px"
                                :src="'/storage' + message.sender.image"
                                :alt="message.sender.name"
                            />
                            <p>{{ message.message }}</p>
                        </li>
                    </ul>
                </div>
                <div class="message-input">
                    <div class="wrap">
                        <form
                            @submit.prevent="sendMessage()"
                            action=""
                            method="post"
                        >
<!--                            <input-->
<!--                                :disabled="Object.keys(user).length === 0"-->
<!--                                type="text"-->
<!--                                placeholder="Write your message..."-->
<!--                                v-model="message"-->
<!--                                v-if="status === 'open'"-->
<!--                            />-->
<!--                            <input-->
<!--                                :disabled="Object.keys(user).length === 0"-->
<!--                                disabled-->
<!--                                type="text"-->
<!--                                :placeholder="status"-->
<!--                                v-model="message"-->
<!--                                v-else-->
<!--                            />-->
                            <button
                                :disabled="!message"
                                type="submit"
                                class="submit"
                            >
                                <i
                                    class="fa fa-paper-plane"
                                    aria-hidden="true"
                                ></i>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axiosInstance from "@/assets/js/axios";
import endpoints from "@/assets/js/api";
import {toast} from "vue3-toastify";
import {hideLoader, showLoader} from "@/assets/js/swal";
import {useUserStore} from "@/store/store";

export default {
    name: "ChatComponent",
    components: {},
    data() {
        return {
            message: "",
            keyword: "",
            messages: [],
            users: [],
            user: {},
            selected_user: {},
            showChat: false,
            chatUsers: [],
            chat: [],
            status: [],
        };
    },
    async created() {
      const userStore = useUserStore();
      this.user = userStore.currentUser;
      await this.getUsersList();
    },
    mounted() {
        this.listenForEvent();
    },
    computed: {
        filteredList() {
            return this.users.filter((user) => {
                return user.name
                    .toLowerCase()
                    .includes(this.keyword.toLowerCase());
            });
        },
    },
    methods: {
        async blockUser(user, status) {
            let formData = new FormData();
            formData.append("user_id", user);
            formData.append("status", status);
            await axiosInstance.post(endpoints.blockUserChatRoute, formData);
            await this.getUsersList();
        },
        async sendMessage() {
            let formData = new FormData();
            formData.append("receiver_id", this.selected_user.id);
            formData.append("message", this.message);
            await axiosInstance.post(endpoints.sendMessageRoute, formData);

            this.message = "";
        },
        async getUsersList() {
            let self = this;

            try {

              showLoader();
              const { data } = await axiosInstance.get(endpoints.getUserListRoute);
              self.users = data.data.users;
              self.chat = data.data.chat;
              hideLoader();

            } catch (e) {

              hideLoader();
              toast.error('Server Error')

            }
        },
        async getMessages(user) {
            let self = this;
            let formData = new FormData();
            this.selected_user = user;
            formData.append("receiver_id", self.user.id);
            formData.append("sender_id", user.id);
            const { data } = await axiosInstance.post(endpoints.getMessagesRoute, formData);
            self.messages = data.data;
            self.status = data.chat.status;
        },
        listenForEvent() {
            // let self = this;
            // window.Echo.private("chat").listen("MessageSent", (e) => {
            //     if (
            //         self.user.id === e.sender.id ||
            //         self.$store.state.user.id === e.receiver.id
            //     ) {
            //         self.messages.push({
            //             id: e.id,
            //             sender: e.sender,
            //             sender_id: e.sender.id,
            //             receiver: e.receiver,
            //             receiver_id: e.receiver.id,
            //             message: e.message,
            //         });
            //     }
            // });
        },
    },
    watch: {

        messages() {
            setTimeout(() => {
                var element = document.getElementById("messages");
                element.scrollTo(0, element.scrollHeight);
            }, 100);
        },
    },
};
</script>

<style scoped>
body {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #27ae60;
    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
    font-size: 1em;
    letter-spacing: 0.1px;
    color: #32465a;
    text-rendering: optimizeLegibility;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
    -webkit-font-smoothing: antialiased;
}

#frame {
    width: 95%;
    min-width: 360px;
    /*max-width: 1000px;*/
    height: 100%;
    min-height: 300px;
    background: #e6eaea;
    /*background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgOCkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgY3g9IjE3NiIgY3k9IjEyIiByPSI0Ii8+PHBhdGggZD0iTTIwLjUuNWwyMyAxMW0tMjkgODRsLTMuNzkgMTAuMzc3TTI3LjAzNyAxMzEuNGw1Ljg5OCAyLjIwMy0zLjQ2IDUuOTQ3IDYuMDcyIDIuMzkyLTMuOTMzIDUuNzU4bTEyOC43MzMgMzUuMzdsLjY5My05LjMxNiAxMC4yOTIuMDUyLjQxNi05LjIyMiA5LjI3NC4zMzJNLjUgNDguNXM2LjEzMSA2LjQxMyA2Ljg0NyAxNC44MDVjLjcxNSA4LjM5My0yLjUyIDE0LjgwNi0yLjUyIDE0LjgwNk0xMjQuNTU1IDkwcy03LjQ0NCAwLTEzLjY3IDYuMTkyYy02LjIyNyA2LjE5Mi00LjgzOCAxMi4wMTItNC44MzggMTIuMDEybTIuMjQgNjguNjI2cy00LjAyNi05LjAyNS0xOC4xNDUtOS4wMjUtMTguMTQ1IDUuNy0xOC4xNDUgNS43IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PHBhdGggZD0iTTg1LjcxNiAzNi4xNDZsNS4yNDMtOS41MjFoMTEuMDkzbDUuNDE2IDkuNTIxLTUuNDEgOS4xODVIOTAuOTUzbC01LjIzNy05LjE4NXptNjMuOTA5IDE1LjQ3OWgxMC43NXYxMC43NWgtMTAuNzV6IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIvPjxjaXJjbGUgZmlsbD0iIzAwMCIgY3g9IjcxLjUiIGN5PSI3LjUiIHI9IjEuNSIvPjxjaXJjbGUgZmlsbD0iIzAwMCIgY3g9IjE3MC41IiBjeT0iOTUuNSIgcj0iMS41Ii8+PGNpcmNsZSBmaWxsPSIjMDAwIiBjeD0iODEuNSIgY3k9IjEzNC41IiByPSIxLjUiLz48Y2lyY2xlIGZpbGw9IiMwMDAiIGN4PSIxMy41IiBjeT0iMjMuNSIgcj0iMS41Ii8+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTkzIDcxaDN2M2gtM3ptMzMgODRoM3YzaC0zem0tODUgMThoM3YzaC0zeiIvPjxwYXRoIGQ9Ik0zOS4zODQgNTEuMTIybDUuNzU4LTQuNDU0IDYuNDUzIDQuMjA1LTIuMjk0IDcuMzYzaC03Ljc5bC0yLjEyNy03LjExNHpNMTMwLjE5NSA0LjAzbDEzLjgzIDUuMDYyLTEwLjA5IDcuMDQ4LTMuNzQtMTIuMTF6bS04MyA5NWwxNC44MyA1LjQyOS0xMC44MiA3LjU1Ny00LjAxLTEyLjk4N3pNNS4yMTMgMTYxLjQ5NWwxMS4zMjggMjAuODk3TDIuMjY1IDE4MGwyLjk0OC0xOC41MDV6IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIvPjxwYXRoIGQ9Ik0xNDkuMDUgMTI3LjQ2OHMtLjUxIDIuMTgzLjk5NSAzLjM2NmMxLjU2IDEuMjI2IDguNjQyLTEuODk1IDMuOTY3LTcuNzg1LTIuMzY3LTIuNDc3LTYuNS0zLjIyNi05LjMzIDAtNS4yMDggNS45MzYgMCAxNy41MSAxMS42MSAxMy43MyAxMi40NTgtNi4yNTcgNS42MzMtMjEuNjU2LTUuMDczLTIyLjY1NC02LjYwMi0uNjA2LTE0LjA0MyAxLjc1Ni0xNi4xNTcgMTAuMjY4LTEuNzE4IDYuOTIgMS41ODQgMTcuMzg3IDEyLjQ1IDIwLjQ3NiAxMC44NjYgMy4wOSAxOS4zMzEtNC4zMSAxOS4zMzEtNC4zMSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvZz48L3N2Zz4=");*/
}
@media screen and (max-width: 360px) {
    #frame {
        width: 100%;
        height: 100vh;
    }
}
#frame #sidepanel {
    float: left;
    min-width: 280px;
    max-width: 340px;
    width: 40%;
    height: 100%;
    background: #66497a;
    color: #f5f5f5;
    overflow: hidden;
    position: relative;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel {
        width: 58px;
        min-width: 58px;
    }
}
#frame #sidepanel #profile {
    width: 80%;
    margin: 25px auto;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile {
        width: 100%;
        margin: 0 auto;
        padding: 5px 0 0 0;
        background: #32465a;
    }
}
#frame #sidepanel #profile.expanded .wrap {
    height: 210px;
    line-height: initial;
}
#frame #sidepanel #profile.expanded .wrap p {
    margin-top: 20px;
}
#frame #sidepanel #profile.expanded .wrap i.expand-button {
    -moz-transform: scaleY(-1);
    -o-transform: scaleY(-1);
    -webkit-transform: scaleY(-1);
    transform: scaleY(-1);
    filter: FlipH;
    -ms-filter: "FlipH";
}
#frame #sidepanel #profile .wrap {
    height: 60px;
    line-height: 60px;
    overflow: hidden;
    -moz-transition: 0.3s height ease;
    -o-transition: 0.3s height ease;
    -webkit-transition: 0.3s height ease;
    transition: 0.3s height ease;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap {
        height: 55px;
    }
}
#frame #sidepanel #profile .wrap img {
    width: 50px;
    border-radius: 50%;
    padding: 3px;
    border: 2px solid #e74c3c;
    height: 50px;
    float: left;
    cursor: pointer;
    -moz-transition: 0.3s border ease;
    -o-transition: 0.3s border ease;
    -webkit-transition: 0.3s border ease;
    transition: 0.3s border ease;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap img {
        width: 40px;
        margin-left: 4px;
    }
}
#frame #sidepanel #profile .wrap img.online {
    border: 2px solid #2ecc71;
}
#frame #sidepanel #profile .wrap img.away {
    border: 2px solid #f1c40f;
}
#frame #sidepanel #profile .wrap img.busy {
    border: 2px solid #e74c3c;
}
#frame #sidepanel #profile .wrap img.offline {
    border: 2px solid #95a5a6;
}
#frame #sidepanel #profile .wrap p {
    float: left;
    margin-left: 15px;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap p {
        display: none;
    }
}
#frame #sidepanel #profile .wrap i.expand-button {
    float: right;
    margin-top: 23px;
    font-size: 0.8em;
    cursor: pointer;
    color: #435f7a;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap i.expand-button {
        display: none;
    }
}
#frame #sidepanel #profile .wrap #status-options {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    width: 150px;
    margin: 70px 0 0 0;
    border-radius: 6px;
    z-index: 99;
    line-height: initial;
    background: #435f7a;
    -moz-transition: 0.3s all ease;
    -o-transition: 0.3s all ease;
    -webkit-transition: 0.3s all ease;
    transition: 0.3s all ease;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options {
        width: 58px;
        margin-top: 57px;
    }
}
#frame #sidepanel #profile .wrap #status-options.active {
    opacity: 1;
    visibility: visible;
    margin: 75px 0 0 0;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options.active {
        margin-top: 62px;
    }
}
#frame #sidepanel #profile .wrap #status-options:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid #435f7a;
    margin: -8px 0 0 24px;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options:before {
        margin-left: 23px;
    }
}
#frame #sidepanel #profile .wrap #status-options ul {
    overflow: hidden;
    border-radius: 6px;
}
#frame #sidepanel #profile .wrap #status-options ul li {
    padding: 15px 0 30px 18px;
    display: block;
    cursor: pointer;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options ul li {
        padding: 15px 0 35px 22px;
    }
}
#frame #sidepanel #profile .wrap #status-options ul li:hover {
    background: #496886;
}
#frame #sidepanel #profile .wrap #status-options ul li span.status-circle {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 5px 0 0 0;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options ul li span.status-circle {
        width: 14px;
        height: 14px;
    }
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li
    span.status-circle:before {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    margin: -3px 0 0 -3px;
    background: transparent;
    border-radius: 50%;
    z-index: 0;
}
@media screen and (max-width: 735px) {
    #frame
        #sidepanel
        #profile
        .wrap
        #status-options
        ul
        li
        span.status-circle:before {
        height: 18px;
        width: 18px;
    }
}
#frame #sidepanel #profile .wrap #status-options ul li p {
    padding-left: 12px;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #profile .wrap #status-options ul li p {
        display: none;
    }
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-online
    span.status-circle {
    background: #2ecc71;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-online.active
    span.status-circle:before {
    border: 1px solid #2ecc71;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-away
    span.status-circle {
    background: #f1c40f;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-away.active
    span.status-circle:before {
    border: 1px solid #f1c40f;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-busy
    span.status-circle {
    background: #e74c3c;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-busy.active
    span.status-circle:before {
    border: 1px solid #e74c3c;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-offline
    span.status-circle {
    background: #95a5a6;
}
#frame
    #sidepanel
    #profile
    .wrap
    #status-options
    ul
    li#status-offline.active
    span.status-circle:before {
    border: 1px solid #95a5a6;
}
#frame #sidepanel #profile .wrap #expanded {
    padding: 100px 0 0 0;
    display: block;
    line-height: initial !important;
}
#frame #sidepanel #profile .wrap #expanded label {
    float: left;
    clear: both;
    margin: 0 8px 5px 0;
    padding: 5px 0;
}
#frame #sidepanel #profile .wrap #expanded input {
    border: none;
    margin-bottom: 6px;
    background: #32465a;
    border-radius: 3px;
    color: #f5f5f5;
    padding: 7px;
    width: 100%;
    /*width: calc(100% - 43px);*/
}
#frame #sidepanel #profile .wrap #expanded input:focus {
    outline: none;
    background: #435f7a;
}
#frame #sidepanel #search {
    border-top: 1px solid #32465a;
    border-bottom: 1px solid #32465a;
    font-weight: 300;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #search {
        display: none;
    }
}
#frame #sidepanel #search label {
    position: absolute;
    margin: 10px 0 0 20px;
}
#frame #sidepanel #search input {
    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
    padding: 10px 0 10px 46px;
    /*width: calc(100% - 25px);*/
    width: 100%;
    border: none;
    background: #79567e;
    color: #f5f5f5;
}
#frame #sidepanel #search input:focus {
    outline: none;
    background: #675180;
}
#frame #sidepanel #search input::-webkit-input-placeholder {
    color: #f5f5f5;
}
#frame #sidepanel #search input::-moz-placeholder {
    color: #f5f5f5;
}
#frame #sidepanel #search input:-ms-input-placeholder {
    color: #f5f5f5;
}
#frame #sidepanel #search input:-moz-placeholder {
    color: #f5f5f5;
}
#frame #sidepanel #contacts {
    height: calc(100% - 177px);
    overflow-y: auto;
    overflow-x: hidden;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #contacts {
        height: calc(100% - 149px);
        overflow-y: scroll;
        overflow-x: hidden;
    }
    #frame #sidepanel #contacts::-webkit-scrollbar {
        display: none;
    }
}
#frame #sidepanel #contacts.expanded {
    height: calc(100% - 334px);
}
#frame #sidepanel #contacts::-webkit-scrollbar {
    width: 8px;
    background: #2c3e50;
}
#frame #sidepanel #contacts::-webkit-scrollbar-thumb {
    background-color: #243140;
}
#frame #sidepanel #contacts ul li.contact {
    position: relative;
    padding: 10px 0 15px 0;
    font-size: 0.9em;
    cursor: pointer;
    border-bottom: 1px solid #ffffff;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #contacts ul li.contact {
        padding: 6px 0 46px 8px;
    }
}
#frame #sidepanel #contacts ul li.contact:hover {
    background: #32465a;
}
#frame #sidepanel #contacts ul li.contact.active {
    background: #794b6f;
    border-right: 5px solid #66497a;
}
#frame #sidepanel #contacts ul li.contact.active span.contact-status {
    border: 2px solid #32465a !important;
}
#frame #sidepanel #contacts ul li.contact .wrap {
    width: 88%;
    margin: 0 auto;
    position: relative;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #contacts ul li.contact .wrap {
        width: 100%;
    }
}
#frame #sidepanel #contacts ul li.contact .wrap span {
    position: absolute;
    left: 0;
    margin: -2px 0 0 -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid #2c3e50;
    background: #95a5a6;
}
#frame #sidepanel #contacts ul li.contact .wrap span.online {
    background: #2ecc71;
}
#frame #sidepanel #contacts ul li.contact .wrap span.away {
    background: #f1c40f;
}
#frame #sidepanel #contacts ul li.contact .wrap span.busy {
    background: #e74c3c;
}
#frame #sidepanel #contacts ul li.contact .wrap img {
    width: 40px;
    border-radius: 50%;
    float: left;
    margin-right: 10px;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #contacts ul li.contact .wrap img {
        margin-right: 0px;
    }
}
#frame #sidepanel #contacts ul li.contact .wrap .meta {
    padding: 5px 0 0 0;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #contacts ul li.contact .wrap .meta {
        display: none;
    }
}
#frame #sidepanel #contacts ul li.contact .wrap .meta .name {
    font-weight: 600;
}
#frame #sidepanel #contacts ul li.contact .wrap .meta .preview {
    margin: 5px 0 0 0;
    padding: 0 0 1px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -moz-transition: 1s all ease;
    -o-transition: 1s all ease;
    -webkit-transition: 1s all ease;
    transition: 1s all ease;
}
#frame #sidepanel #contacts ul li.contact .wrap .meta .preview span {
    position: initial;
    border-radius: initial;
    background: none;
    border: none;
    padding: 0 2px 0 0;
    margin: 0 0 0 1px;
    opacity: 0.5;
}
#frame #sidepanel #bottom-bar {
    position: absolute;
    width: 100%;
    bottom: 0;
}
#frame #sidepanel #bottom-bar button {
    float: left;
    border: none;
    width: 50%;
    padding: 10px 0;
    background: #675180;
    color: #f5f5f5;
    cursor: pointer;
    font-size: 0.85em;
    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #bottom-bar button {
        float: none;
        width: 100%;
        padding: 15px 0;
    }
}
#frame #sidepanel #bottom-bar button:focus {
    outline: none;
}
#frame #sidepanel #bottom-bar button:nth-child(1) {
    border-right: 1px solid #2c3e50;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #bottom-bar button:nth-child(1) {
        border-right: none;
        border-bottom: 1px solid #2c3e50;
    }
}
#frame #sidepanel #bottom-bar button:hover {
    background: #435f7a;
}
#frame #sidepanel #bottom-bar button i {
    margin-right: 3px;
    font-size: 1em;
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #bottom-bar button i {
        font-size: 1.3em;
    }
}
@media screen and (max-width: 735px) {
    #frame #sidepanel #bottom-bar button span {
        display: none;
    }
}
#frame .content {
    float: right;
    width: 60%;
    height: 100%;
    overflow: hidden;
    position: relative;
}
@media screen and (max-width: 735px) {
    #frame .content {
        width: calc(100% - 58px);
        min-width: 300px !important;
    }
}
@media screen and (min-width: 900px) {
    #frame .content {
        width: calc(100% - 340px);
    }
}
#frame .content .contact-profile {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #f5f5f5;
}
#frame .content .contact-profile img {
    width: 40px;
    border-radius: 50%;
    float: left;
    margin: 9px 12px 0 9px;
}
#frame .content .contact-profile p {
    float: left;
}
#frame .content .contact-profile .social-media {
    float: right;
}
#frame .content .contact-profile .social-media i {
    margin-left: 14px;
    cursor: pointer;
}
#frame .content .contact-profile .social-media i:nth-last-child(1) {
    margin-right: 20px;
}
#frame .content .contact-profile .social-media i:hover {
    color: #435f7a;
}
#frame .content .messages {
    height: 58vh;
    /*min-height: calc(100% - 93px);*/
    /*max-height: calc(100% - 93px);*/
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
}
@media screen and (max-width: 735px) {
    #frame .content .messages {
        max-height: calc(100% - 105px);
    }
}
#frame .content .messages::-webkit-scrollbar {
    width: 8px;
    background: rgba(0, 0, 0, 0);
}
#frame .content .messages::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
}
#frame .content .messages ul li {
    display: inline-block;
    clear: both;
    float: left;
    margin: 15px 15px 5px 15px;
    width: calc(100% - 25px);
    font-size: 0.9em;
}
#frame .content .messages ul li:nth-last-child(1) {
    margin-bottom: 20px;
}
#frame .content .messages ul li.sent img {
    margin: 6px 8px 0 0;
}
#frame .content .messages ul li.sent p {
    background: #794b6f;
    color: #f5f5f5;
}
#frame .content .messages ul li.replies img {
    float: right;
    margin: 6px 0 0 8px;
}
#frame .content .messages ul li.replies p {
    background: #794b6f;
    color: #f5f5f5;
    float: right;
}
#frame .content .messages ul li img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    float: left;
}
#frame .content .messages ul li p {
    display: inline-block;
    padding: 10px 15px;
    border-radius: 20px;
    max-width: 205px;
    line-height: 130%;
}
@media screen and (min-width: 735px) {
    #frame .content .messages ul li p {
        max-width: 300px;
    }
}
#frame .content .message-input {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 99;
    padding: 10px 10px;
}
#frame .content .message-input .wrap {
    position: relative;
}
#frame .content .message-input .wrap input {
    font-family: "proxima-nova", "Source Sans Pro", sans-serif;
    float: left;
    border: none;
    width: calc(100% - 60px);
    padding: 11px 32px 10px 8px;
    font-size: 0.8em;
    color: #32465a;
}
@media screen and (max-width: 735px) {
    #frame .content .message-input .wrap input {
        padding: 15px 32px 16px 8px;
    }
}
#frame .content .message-input .wrap input:focus {
    outline: none;
}
#frame .content .message-input .wrap .attachment {
    position: absolute;
    right: 60px;
    z-index: 4;
    margin-top: 10px;
    font-size: 1.1em;
    color: #435f7a;
    opacity: 0.5;
    cursor: pointer;
}
@media screen and (max-width: 735px) {
    #frame .content .message-input .wrap .attachment {
        margin-top: 17px;
        right: 65px;
    }
}
#frame .content .message-input .wrap .attachment:hover {
    opacity: 1;
}
#frame .content .message-input .wrap button {
    float: right;
    border: none;
    width: 50px;
    padding: 12px 0;
    cursor: pointer;
    background: #532d5f;
    color: #f5f5f5;
}
@media screen and (max-width: 735px) {
    #frame .content .message-input .wrap button {
        padding: 16px 0;
    }
}
#frame .content .message-input .wrap button:hover {
    background: #435f7a;
}
#frame .content .message-input .wrap button:focus {
    outline: none;
}

li {
    list-style: none;
}
</style>
